import React, { useEffect } from 'react';
import { DaOffer, Platform } from '../../types';
import cn from 'classnames';

import s from './Banner.scss';

export interface Props {
  banner: NonNullable<DaOffer['asset']['creative']['adhesion']>;
  platform: Platform;
  onCtaClick: (url?: string) => void;
}

const Banner: React.FC<Props> = ({
  banner: bannerOffer,
  platform,
  onCtaClick,
}) => {
  // Mobile is optional but usually comes as empty object so fallback to desktop when not present
  let banner: Partial<typeof bannerOffer.desktop> = bannerOffer.desktop;
  if (
    platform === 'mobile' &&
    bannerOffer.mobile &&
    Object.keys(bannerOffer.mobile).length > 0 &&
    bannerOffer.mobile.bannerImage
  ) {
    banner = bannerOffer.mobile!;
  }

  // I think this is the only way to avoid flickering when we swap images :(
  useEffect(() => {
    if (banner.bannerImageHover) {
      const preload = new Image();
      preload.src = banner.bannerImageHover;
    }
  });

  if (!bannerOffer || !banner) {
    return null;
  }

  return (
    <div
      className={cn(s['root'], !banner.bannerImageHover && s['single-image'])}
    >
      <a
        href={banner.bannerURL}
        onClick={() => onCtaClick(banner.bannerURL)}
        target="_blank"
        rel="noreferrer"
      >
        {banner.bannerImageHover && (
          <img
            className={s['hidden']}
            src={banner.bannerImageHover}
            alt="Banner"
            loading="lazy"
          />
        )}
        <img
          className={s['main']}
          src={banner.bannerImage}
          alt="Banner"
          loading="lazy"
        />
      </a>
    </div>
  );
};

export default Banner;
